import React, { useRef, useEffect } from "react";
import { useOutlet } from "react-router-dom";
import styled from "styled-components";
import Header from "../components/Header";
import Footer from "../components/Footer";

export const AllLayout = (oProps: any) => {
  const outlet = useOutlet();
  const topRef = useRef<any>(null);

  useEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "auto" });
    }
  }, [outlet]);
  return (
    <Style>
      <div className="screen" ref={topRef}>
        <Header />
        {outlet}
        <Footer />
      </div>
    </Style>
  );
};

export const Style = styled.div`
  .screen {
    width: 100%;
    height: 100%;
    min-height: 100vh;
  }
`;
